import { render } from "./DashboardSwitcher.vue?vue&type=template&id=69e4434d"
import script from "./DashboardSwitcher.vue?vue&type=script&lang=js"
export * from "./DashboardSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__